<template>
  <div class="services services--quality">
    <HeroText
      :heroH1="''"
      :heroH2="currentPage.fields.title"
      :heroP="currentPage.fields.intro"
      :internalPage="true"/>
    <!-- Slides -->
    <div class="internal-page-slides">
      <div
        v-for="(slide, index) of slidesArray"
        :key="index"
        class="internal-page-slide">
        <InternalTitleDescriptionImageParallax
          :images="slide.images"
          :contents="slide.contents"
          :contentLeft="slide.contentLeft"
          :rellaxSpeed="rellaxSpeed"/>
      </div>
    </div>
    <InternalNextPages :services="true" :company="true"/>
    <glaxiFooter/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import HeroText from '@/components/HeroText/HeroText.vue'
import InternalTitleDescriptionImageParallax from '@/components/InternalTitleDescriptionImageParallax/InternalTitleDescriptionImageParallax.vue'
import InternalNextPages from '@/components/InternalNextPages/InternalNextPages.vue'
import GlaxiFooter from '@/components/GlaxiFooter/GlaxiFooter.vue'
import matchMedia from '@/mixins/matchMedia.js'

export default {
  name: 'Quality',
  mixins: [matchMedia],
  components: {
    HeroText,
    InternalTitleDescriptionImageParallax,
    InternalNextPages,
    GlaxiFooter
  },
  props: {
    currentPage: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    slidesArrayIt: [
      {
        images: [
          {
            'landscape': require('@/assets/quality/quality-01-landscape.jpg'),
            'portrait': require('@/assets/quality/quality-01-portrait.jpg')
          }
        ],
        contents: [
          {
            title: 'Genuinità degli ingredienti',
            description: 'Tutto parte da una scelta ben precisa, quella di dire NO a olio di palma, grassi idrogenati, conservanti, coloranti ed edulcoranti artificiali. Per il nostro pane selezioniamo gli ingredienti con massima cura e attenzione. Non ci accontentiamo di farine e lieviti qualsiasi, ma cerchiamo e scegliamo materiali di elevatissima qualità, individuando quelli ideali e specifici per ogni linea produttiva.',
            labelContent: 'Ingredienti semplici e una lavorazione che rispetta i tempi naturali della lievitazione del pane senza irrompere nel processo di panificazione o aggiungere qualcosa che possa modificarne la genuinità. Solo elementi naturali e di qualità: dalle farine al sale, dal lievito all’olio extravergine di oliva.'
          },
          {
            title: 'Congelamento',
            description: 'Usiamo l’unico conservante naturale che permette di avere un prodotto come appena sfornato, senza aggiunta di sostanze chimiche: il freddo. Per garantire panificati sempre freschi, morbidi e naturali.',
            labelContent: '<p>Un prodotto naturale, esattamente uguale a quello fresco, che si scongela e prepara in tempi rapidi. Per chi opera nella ristorazione, è questo il grande vantaggio di scegliere un panificato surgelato. Avendo così sempre a disposizione una grande varietà e quantità di prodotti da forno.</p><strong>100% natura. 0% alcool e chimica.</strong><p>Serio Galante non avrebbe mai permesso di manipolare in modo artificiale i panificati frutto di anni di passione e dedizione. Per questo Glaxi Pane, nel passaggio da forno a industria alimentare ha pensato al congelamento come metodo di conservazione. Quindi abbiamo scelto di dire no all’alcool etilico che modifica le caratteristiche organolettiche del pane e abbiamo sposato il congelamento, quale unico modo naturale per conservare la freschezza dei panificati conferendo loro, da scongelati, esattamente la stessa fragranza e lo stesso profumo dei prodotti di giornata.</p>'
          }
        ],
        contentLeft: true
      },
      {
        images: [
          {
            'landscape': require('@/assets/quality/quality-02-landscape.jpg'),
            'portrait': require('@/assets/quality/quality-02-portrait.jpg')
          },
          {
            'landscape': require('@/assets/quality/quality-03-landscape.jpg'),
            'portrait': require('@/assets/quality/quality-03-portrait.jpg')
          }
        ],
        contents: [
          {
            title: 'Ricerca',
            description: 'Ascoltiamo, studiamo e cerchiamo di interpretare le esigenze emergenti per proporre prodotti all’avanguardia e utilizzare le migliori tecnologie presenti sul mercato.',
            labelContent: '<p>Abbiamo intrapreso un percorso di innovazione che non ha intenzione di fermarsi. Dagli ampliamenti di linea ai nuovi silos che permettono una migliore efficienza grazie al controllo del dosaggio e al monitoraggio, passando per la ristrutturazione della sale di preparazione degli impasti e l’acquisto di nuovi macchinari 4.0 che rendono più semplice e sicura la tracciabilità, agevolando l’operatività e la qualità di vita dei lavoratori.<br> Un cammino fondamentale teso a rendere più agevoli processi e servizi, garantendo sempre l’elevata qualità dei nostri panificati.</p><strong>I clienti sono i nostri primi ricercatori</strong><p>Insieme ai clienti facciamo continua ricerca e sperimentiamo nuovi abbinamenti, formati e dimensioni di panificati. Il pane con curcuma e semi di lino, quello di malto e orzo o ancora quello decorato con semi di chia sono solo alcuni degli esempi della nostra voglia di innovare, di proporre nuove alternative e di stupire.</p>'
          },
          {
            title: 'Esperienza',
            description: 'Impastiamo e sforniamo pane da oltre 60 anni. Ancora oggi nella nostra industria di panificazione, usiamo le preziose ricette di famiglia che combinate alla lavorazioni più moderne rendono il nostro pane riconoscibile al primo morso.',
            labelContent: 'Fare il pane è un’arte e richiede conoscenza, studio costante e aggiornamento. Da sempre la comprensione dei comportamenti della struttura molecolare del panificato, delle materie prime e di come tutti questi elementi reagiscono alle lavorazioni guidano la nostra produzione.'
          },
          {
            title: 'Ricerca',
            description: 'Abbiamo scelto di garantire a chi ci sceglie tutta la sicurezza e l’affidabilità di servizi e prodotti certificati.',
            labelContent: 'Processi produttivi su standard HACCP<br> Certificazione ISO 9001:2015<br> Certificazione IFS (INTERNATIONAL FOOD STANDARD)<br> Autorizzazione alla produzione biologica'
          }
        ],
        contentLeft: false
      }
    ],
    slidesArrayEn: [
      {
        images: [
          {
            'landscape': require('@/assets/quality/quality-01-landscape.jpg'),
            'portrait': require('@/assets/quality/quality-01-portrait.jpg')
          }
        ],
        contents: [
          {
            title: 'Genuineness of the ingredients',
            description: 'Everything starts from a precise choice, that of saying NO to palm oil, hydrogenated fats, preservatives, dyes and artificial sweeteners. For our bread we select the ingredients with the utmost care and attention. We are not satisfied with just any flour and yeast, but we seek out and choose the highest quality materials, identifying those that are ideal and specific for every production line.',
            labelContent: 'Simple ingredients and a process that respects the natural times of the bread\'s leavening without intruding during the baking process or adding anything that could modify its genuineness. Only natural and high quality ingredients: from the flours to the salt, from the yeast to the extra virgin olive oil.'
          },
          {
            title: 'Freezing',
            description: 'We use the only natural preservative that allows us to have a product exactly like a freshly baked one, without the addition of chemical substances: the cold. To ensure bread products that are always fresh, soft and natural.',
            labelContent: '<p>A natural product, exactly the same as the fresh one, that is rapidly thawed and prepared. For those who work in catering, this is the great advantage of choosing a frozen bread product. This way, you will always have a great variety and quantity of bakery products available.</p><strong>100% natural. 0% alcohol and chemicals.</strong><p> Serio Galante would never have allowed artificially manipulating the bread that was the fruit of years of passion and dedication. For this reason, Glaxi Pane, in the passage from the bakery to the food industry has thought about freezing as the best conservation method. We have therefore chosen to say no to ethyl alcohol that modifies the sensory characteristics of the bread and we have adopted freezing alone, which is the only natural way to preserve the freshness of bread products, giving them, after thawing, exactly the same fragrance and the same aroma of the day\'s fresh-baked products.</p>'
          }
        ],
        contentLeft: true
      },
      {
        images: [
          {
            'landscape': require('@/assets/quality/quality-02-landscape.jpg'),
            'portrait': require('@/assets/quality/quality-02-portrait.jpg')
          },
          {
            'landscape': require('@/assets/quality/quality-03-landscape.jpg'),
            'portrait': require('@/assets/quality/quality-03-portrait.jpg')
          }
        ],
        contents: [
          {
            title: 'Research',
            description: 'We listen, we study and we try to interpret the emerging needs so that we can propose cutting-edge products and use the best technologies available on the market.',
            labelContent: '<p>We have embarked on a path of innovation that we have no intention of stopping. From the extensions of the line to the new silos which allow greater efficiency thanks to dosage control and monitoring, passing through the remodelling of the preparation rooms of the doughs and the purchase of new 4.0 machinery that makes traceability easier and more secure, facilitating not only the operation, but also the quality of life of the workers.<br> An essential path aimed at facilitating processes and services, always guaranteeing the high quality of our bread products.</p><strong>Customers are our first researchers.</strong><p>Together with our customers we carry out continuous research and try out new combinations, shapes and sizes of bread products. The bread with turmeric and linseed, the one with malt and barley or even the one decorated with Chia seeds are just a few examples of our desire to innovate, to propose new alternatives and to amaze.</p>'
          },
          {
            title: 'Experience',
            description: 'We\'ve been kneading and baking bread for over 60 years. Still today in our baking industry, we use the precious family recipes that, combined with the most advanced machining operations, make our bread recognisable from the first bite.',
            labelContent: 'Bread making is an art that requires knowledge, constant study and updating. Our production has always been guided by the understanding of the behaviour of the molecular structure of the bread product, of the raw materials and how all these elements react.'
          },
          {
            title: 'Research',
            description: 'We have chosen to ensure to everyone who has chosen us all the safety and reliability of certified services and products.',
            labelContent: 'Production processes following the HACCP standard<br> ISO Certification 9001:2015<br> IFS certification (INTERNATIONAL FOOD STANDARD)<br> Authorisation for organic production.'
          }
        ],
        contentLeft: false
      }
    ]
  }),
  computed: {
    ...mapGetters([
      'lang'
    ]),
    rellaxSpeed: {
      get () {
        if (typeof this.matchMedia !== undefined && this.matchMedia === 'small') return 0
        if (typeof this.matchMedia !== undefined && this.matchMedia === 'medium') return -2
        return -1
      }
    },
    slidesArray: {
      get () {
        if (this.lang === undefined) return undefined
        if (this.lang === 'it') return this.slidesArrayIt
        return this.slidesArrayEn
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../Services/services.scss";
</style>
